export default {
  objectIsEmpty(obj) {
    return Object.keys(obj).length === 0;
  },
  dateFomatter(timestamp) {
    if(!timestamp){
       return "";
    }
    const date = new Date(timestamp);
    return date.getFullYear() +
      '-' +
      parseInt(date.getMonth() + 1) +
      '-' +
      date.getDate() +
      ' ' +
      date.getHours() +
      ':' +
      date.getMinutes() +
      ':' +
      date.getSeconds();
  },
  dictionaryFormatter(data, dic) {
    return dic[data];
  }
}



// WEBPACK FOOTER //
// ./packages/table-extend/src/util.js